<template>
    <div id="container-footer" class="h-full grid xl:grid-cols-3 md:grid-cols-2 sm:grid-cols-1 gap-4 mx-normal max-md:mx-min dark:text-primary-dark-text">
        <div v-if="!store.isMovil" id="container-name-slogan" class="h-full">
            <div id="name-slogan" class="relative flex flex-col justify-center h-full">
                <h1 id="name" class="leading-none font-bloggerB text-principal-desktop max-md:text-principal-mobile">
                    {{ t('name') }}
                </h1>
                <span id="slogan" class="leading-none font-monserratM text-content-desktop max-md:text-ticket-mobile">
                    {{ t('slogan') }}
                </span>
            </div>
        </div>
        <div id="container-networks-copyright" class="flex flex-col items-center justify-evenly h-full">
            <div id="container-networks" class="flex gap-4">
                <a v-if="route.name != 'Store'" class="flex justify-center" href="https://www.facebook.com/godofredorf" target="_blank">
                    <span class="h-7 w-7">
                        <img src="/img/Facebook.png"
                            alt="Logo de Facebook">
                    </span>
                </a>
                <a v-if="route.name != 'Store'" class="flex justify-center" href="https://www.instagram.com/caminandoconjesusmedios/"
                    target="_blank">
                    <span class="h-7 w-7">
                        <img src="/img/Instagram.png"
                            alt="Logo de Instagram">
                    </span>
                </a>
                <a v-if="route.name != 'Store'" class="flex justify-center" href="https://www.youtube.com/@ccjmedios6427" target="_blank">
                    <span class="h-7 w-7">
                        <img src="/img/YouTube.png"
                            alt="Logo de Youtube">
                    </span>
                </a>

                <a v-if="route.name == 'Store'" class="flex justify-center" href="https://www.facebook.com/profile.php?id=61552239260818" target="_blank">
                    <span class="h-7 w-7">
                        <img src="/img/Facebook.png"
                            alt="Logo de Facebook">
                    </span>
                </a>
                <a v-if="route.name == 'Store'" class="flex justify-center" href="https://www.instagram.com/tiendaccj/"
                    target="_blank">
                    <span class="h-7 w-7">
                        <img src="/img/Instagram.png"
                            alt="Logo de Instagram">
                    </span>
                </a>
            </div>
            <div id="container-copyright" class="text-center">
                <span class="text-xs font-bloggerM">
                    &#169 {{ t('copyright') }}
                </span>
            </div>
        </div>
    </div>
</template>

<script setup>
import { useTranslation } from 'i18next-vue';
import { generalStore } from '@/stores';

const { t } = useTranslation();
const store = generalStore();
const route = store.route;
</script>